<template>
    <div class="memorandum_create_block ">
        <div class="row">

            <div class="col-xl-4 col-lg-4 col-sm-12 col-md-12 col-xs-12">
                <left_side_org
                    @org_loaded="get_params"
                    @org_change_state="set_org_state"
                    @show_base_settings="show_base_settings"
                    @create_location="add_location"
                    :provider_type=provider_type
                    :has_settings="this.has_settings"
                >
                </left_side_org>
            </div>

            <div class="col-xl-8 col-lg-8 col-sm-12 col-md-12 col-xs-12">
                <div id="panel-50" class="panel">
                    <b-overlay :show="is_load" rounded="sm">
                        <div class="panel-hdr ">
                            <h2 >
                                <b-form-checkbox class="in_head" switch size="lg"  @change="check_location_all"   v-model=all_loc_checked></b-form-checkbox>
                                {{__t(this.provider_type.toUpperCase() + '_REST_LIST')}}
                            </h2>

                            <div class="panel-toolbar ml-2">

                                <div class="d-flex position-relative ml-auto" style="max-width: 8rem;">
                                    <i class="fal fa-search position-absolute pos-left fs-lg px-2 py-1 mt-1 fs-xs"></i>
                                    <b-form-input
                                        id="input-live"
                                        class="form-control form-control-sm pl-5"
                                        v-model="search_param"
                                        aria-describedby="input-live-help input-live-feedback"
                                        :placeholder="__t('SEARCH')"
                                        trim
                                    ></b-form-input>
                                </div>
                            </div>
                        </div>
                        <div class="panel-container show">
                            <div class="panel-content loc_g">

                                <ul class="nav-menu   mb-sm-4 mb-md-0 rounded " v-if="draw_locations.length > 0">
                                    <li class="location_block" v-for="org in draw_locations" >
                                        <b-overlay :show="org.is_loading" rounded="sm">
                                            <a class="waves-effect waves-themed pl-1 pr-1" v-on:click="edit_location(org)">
                                                <div class="loc_click p-2" v-on:click.stop.prevent="setActiveLocation(org)">
                                                    <b-form-checkbox :name="'loc_' + org.id" :id="'loc_' + org.id" :key="org.id" v-model=org.is_checked></b-form-checkbox>
                                                </div>

                                                <div class="nav-link-text color-black d-block" >
                                                    <div>
                                                        {{org.title}}
                                                        <sup>
                                                            <span  class="badge badge-warning ml-2">
                                                              {{org.uniq_id}}
                                                        </span>
                                                        </sup>

                                                    </div>

                                                    <div class="small" v-if="obj_to_null(org.linked_restaurant)">
                                                        LINK_REST: {{org.linked_restaurant.address}} | {{org.linked_restaurant.title}}
                                                    </div>
                                                </div>


                                                <div class="buttons">
                                                    <button class="hidden-sm-down mr-5 btn btn-icon btn-sm btn-danger color-white shadow-0 rounded-circle waves-effect waves-themed"
                                                            v-on:click.prevent.stop="remove_location(org)">
                                                        <i class="fal fa-trash"></i>
                                                    </button>

                                                    <button
                                                        v-if="has_json"
                                                        class="mr-4 btn btn-icon btn-sm btn-warning color-white shadow-0 rounded-circle waves-effect waves-themed"
                                                        v-on:click.prevent.stop="get_json(org)">
                                                        <i class="fal fa-building"></i>
                                                    </button>

                                                    <button
                                                        v-if="has_sync"
                                                        class="mr-2 btn btn-icon btn-sm btn-success shadow-0 rounded-circle waves-effect waves-themed"
                                                        v-on:click.prevent.stop="make_sync(org)">
                                                        <i class="fal fa-sync"></i>
                                                    </button>

                                                </div>

                                            </a>
                                        </b-overlay>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </b-overlay>
                </div>
            </div>
        </div>

        <review_location_modal></review_location_modal>

    </div>
</template>

<script>
import left_side_org from "../../catalog/organizations/list/left_side";
import Review_location_modal from "../location/review_location_modal.vue";
export default {
    name: "base_review",
    components: {Review_location_modal, left_side_org},
    props : {
        provider : {
            type : Object,
            required : true,
        },
    },

    data() {
        return {
            locations: [],
            is_load: true,
            search_param: "",
            active_org : null,
            review_provider : {
                'id' : this.provider_id,
                'type' : this.provider_type,
                'has_settings' : false,
            }
        }
    },

    created() {
        if(window.hasOwnProperty("review_api")) {
            this.load_review_provider();
        }

        EventBus.$on('loaded_api', this.load_review_provider)
    },

    methods: {

        load_review_provider() {
            review_api.get('/reviews/sources/' + this.provider_id).then(({data}) => {
                if (data.status === "operation_success") {
                    this.review_provider = {...this.review_provider,...data.data};
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        },

        check_location_all() {
            let state = !this.is_all_location_selected;
            this.draw_locations.map(item => {
                item.is_checked = state;
            });
        },

        get_json(location) {
            window.open("/internal/v1/catalog/reviews/locations/" + location.id + "/json");
        },

        make_sync(item) {
            this.push_sync(item)
        },

        push_sync(location) {
            location.is_loading = true;

            review_api.patch('/locations/' + location.id + '/reviews').then(({data}) => {
                if (data.status === "operation_success") {
                    location.is_loading = false;
                    let resp = data.data;
                    EventBus.$emit('show_toast', {
                        err: "OK ",
                        type: "success",
                        title: "In Progress"
                    })
                }
            }).catch(({response}) => {
                location.is_loading = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
            this.$emit('make_sync', location);
        },

        show_base_settings() {
            EventBus.$emit('auth_manager',{
                'provider_id' : this.provider_id,
                'provider_type' : this.provider_type
            })
        },

        async get_params() {
            //   this.organizations = [];
            this.locations = [];
            this.is_load = true;

            this.load_locations().then(({data}) => {
                if (data.status === "operation_success") {
                    let locations = data.data;
                    locations.map(item => {
                        item.is_loading = false;
                        item.is_checked = false;
                        this.locations.push(item);
                    })
                }
                this.is_load = false;
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },

        async set_org_state(org) {
            if(org.hasOwnProperty('is_active') && org.is_active) {
                this.active_org = org;
            }
            else {
                this.active_org = null;
            }
        },

        async load_locations() {
            return review_api.get('/reviews/sources/' + this.provider_id + "/locations");
        },

        head_action () {
            this.$emit('head_action');
        },

        add_location(organization) {
            EventBus.$emit("location_edit",{
                'org_id' : organization.id,
                'org_obj' : organization,
                'location_id' : 0,
                'provider_id' : this.provider_id
            });
        },

        edit_location(location) {
            EventBus.$emit("location_edit",{
                'org_id' : 0,
                'org_obj' : null,
                'location_id' : location.id,
                'provider_id' : this.provider_id
            });
        },

        remove_location(location) {
            const is_ok = confirm_me(this.__t('REMOVE?'));
            is_ok.then(res => {
                location.is_loading = true;
                api.delete('/internal/v1/review/locations/' + location.id).then(({data}) => {
                    if (data.status === "operation_success") {
                        EventBus.$emit('reload_locations');
                    }
                }).catch(({response}) => {
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status
                    })
                });
            });
        },

        setActiveLocation(location) {
            location.is_checked = !location.is_checked;
        },

    },

    computed: {

        has_json() {
            return true;
        },

        has_sync() {
            return true;
        },

        has_settings() {
            if(this.review_provider.hasOwnProperty('has_settings')) {
                return this.review_provider.has_settings;
            }
            return false;
        },

        provider_id() {
            return parseInt(this.provider.id);
        },

        provider_type() {
            return this.provider.type;
        },

        draw_locations()
        {
            let items = this.locations;

            if(this.active_org != null) {
                items = items.filter(item => {
                    return parseInt(item.parent_id) === parseInt(this.active_org.id);
                });
            }

            if(this.search_param.length > 1) {
                items = items.filter(item => {
                    let inside_title = String(item.title.toLowerCase()).match(new RegExp(this.search_param, "gi"));
                    let inside_uniq  = String(item.uniq_id.toLowerCase()).match(new RegExp(this.search_param, "gi"));

                    return inside_title || inside_uniq;
                })
            }
            return items;
        },

        all_loc_checked: {
            get () {
                return this.is_all_location_selected;
            },
            set (val) {

            }
        },

        is_all_location_selected() {
            let items = this.draw_locations.filter(item => {
                return !item.is_checked;
            });
            return items.length <= 0;
        },

        checked_locations() {
            return  this.draw_locations.filter(item => {
                return item.is_checked;
            });
        },
    }

}
</script>

<style scoped>
a.active_filter {
    border-left: 3px solid #584475;
    background: #eee;
}
</style>
